import { Injectable, inject } from '@angular/core'
import { Event, Router, RoutesRecognized } from '@angular/router'
import { filter, pairwise } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class UrlService {
  private router = inject(Router)

  private previousUrl?: string

  constructor() {
    this.router.events
      .pipe(
        filter((evt: Event): evt is RoutesRecognized => evt instanceof RoutesRecognized),
        pairwise(),
      )
      .subscribe((events: RoutesRecognized[]) => {
        this.previousUrl = events[0].urlAfterRedirects
      })
  }

  public getPreviousUrl() {
    return this.previousUrl
  }
}
